export default interface ProjectHead {
    id: number;
    code: string;
}

export const projectHeadDefaultProps: ProjectHead = {
    id: 0,   
    code: "",
}